import Hokej from './Hokej'

const Rukomet = () => <Hokej calculatorType='Rukomet' />

export default Rukomet
